module.exports = __webpack_public_path__ + "img/under-maintenance-dark.80041b76.svg";